import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import { COLUMNS, SORTABLE_COLUMN_IDS } from './columnConfig';

const HEADER_STYLE: React.CSSProperties = {
    padding: '2px 4px',
    borderRight: '1px solid #e0e0e0',
    borderTop: '1px solid #e0e0e0',
    borderBottom: '1px solid #e0e0e0',
    boxSizing: 'border-box',
    fontWeight: 700,
    backgroundColor: '#fff',
};

const STICKY_HEADER_STYLE: React.CSSProperties = {
    ...HEADER_STYLE,
    position: 'sticky',
    zIndex: 10,
    boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
};

export interface SortConfig {
    field: string;
    direction: 'asc' | 'desc';
}

export interface TableHeaderProps {
    sortConfig?: SortConfig | null;
    onSort?: (field: string) => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({ sortConfig, onSort }) => {
    return (
        <TableHead component="div" style={{ display: 'contents' }}>
            <TableRow
                component="div"
                style={{
                    display: 'flex',
                    position: 'sticky',
                    top: 0,
                    zIndex: 11,
                    backgroundColor: '#fff',
                    margin: 0,
                    padding: 0,
                    borderBottom: '1px solid #e0e0e0',
                    minWidth: 'max-content',
                }}
            >
                {COLUMNS.map((col) => {
                    const isSticky = !!col.sticky;
                    const isFirstThree = col.id === 'description' || col.id === 'supplier' || col.id === 'location';
                    const isSortable = SORTABLE_COLUMN_IDS.includes(col.id);
                    const isActiveSort = sortConfig?.field === col.id;
                    const cellStyle: React.CSSProperties = {
                        ...(isSticky ? STICKY_HEADER_STYLE : HEADER_STYLE),
                        ...(isSticky && col.stickyLeft !== undefined ? { left: col.stickyLeft } : {}),
                        width: col.width,
                        minWidth: col.minWidth,
                        maxWidth: col.width,
                        textAlign: col.align,
                        cursor: isSortable && onSort ? 'pointer' : 'default',
                        height: 120,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: isFirstThree ? 'flex-start' : 'center',
                        writingMode: isFirstThree ? 'horizontal-tb' : 'vertical-rl',
                        transform: isFirstThree ? 'none' : 'rotate(180deg)',
                        gap: 4,
                    };
                    const SortIcon = isActiveSort && sortConfig?.direction === 'desc' ? ArrowDownward : ArrowUpward;

                    return (
                        <TableCell
                            key={col.id}
                            component="div"
                            style={cellStyle}
                            padding="none"
                            onClick={isSortable ? () => onSort?.(col.id) : undefined}
                        >
                            <span>{col.header}</span>
                            {isSortable && isActiveSort && (
                                <SortIcon style={{ fontSize: 16, flexShrink: 0 }} />
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
};

export default React.memo(TableHeader);
